<template>
  <step :active="0"></step>
  <div class="formDiv">
    <van-form @failed="onFailed" @submit="onSubmit">
      <van-cell-group>
        <!-- 循环显示 -->
        <div v-for="item in formItems" :key="item.key">
          <van-field
            v-if="
              item.key !== 'Gender' &&
              item.key !== 'Country' &&
              item.key !== 'Province' &&
              item.key !== 'City' &&
              item.key !== 'Trade' &&
              item.key !== 'photo' &&
              item.key !== 'IDCardType' &&
              item.key !== 'ExtField1' &&
              item.key !== 'ExtField2'
            "
            v-model="formMg[item.key]"
            :name="item.key"
            :label="item.Name"
            :rules="rulesAll[item.key]"
            :class="item.IsMust ? 'requiredItem' : ''"
            :readonly="
              (item.key === 'Mobile' && tabac === 'dl') ||
              (item.key === 'Email' && tabac === 'gat')
            "
          />
          <!-- 头像 -->
          <van-field
            v-if="item.key === 'photo'"
            :name="formMg[item.key]"
            label="头像"
            :rules="rulesAll.photo"
            :class="item.IsMust ? 'photoForm requiredItem' : 'photoForm'"
            v-model="formMg[item.key]"
          >
            <template #input>
              <cropper @send-photo="sendphoto" />
            </template>
          </van-field>
          <!-- gender -->
          <van-field
            v-if="item.key === 'Gender'"
            :class="item.IsMust ? 'requiredItem' : ''"
            :name="item.key"
            :label="item.Name"
            :rules="rulesAll.Gender"
          >
            <template #input>
              <van-radio-group v-model="formMg.Gender" direction="horizontal">
                <van-radio name="男">男</van-radio>
                <van-radio name="女">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 国家选择pc -->
          <template v-if="item.key === 'Country'">
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem' : ''"
                :readonly="true"
                v-model="formMg.Country"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.Country"
              >
              </van-field>
              <select v-model="formMg.Country" @change="changeCountry">
                <option
                  v-for="(item, index) in columns"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 国家 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Country"
              is-link
              readonly
              name="Country"
              :label="item.Name"
              @click="showPicker = true"
              :rules="rulesAll.Country"
            >
            </van-field>
            <van-popup v-model:show="showPicker" position="bottom">
              <van-picker
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </template>
          <!-- 省份 -->
          <template v-if="item.key === 'Province'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.Province"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.Province"
                :disabled="formMg.Country !== '中国'"
              >
              </van-field>
              <select
                v-model="formMg.Province"
                @change="changeProvince"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsProvince"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-if="!isPC"
              v-model="formMg.Province"
              is-link
              readonly
              :name="item.key"
              :label="item.Name"
              @click="columnsProvince.length > 0 ? (showPickerPro = true) : ''"
              :rules="rulesAll.Province"
              :disabled="formMg.Country !== '中国'"
            />
            <van-popup v-model:show="showPickerPro" position="bottom">
              <van-picker
                :columns="columnsProvince"
                @confirm="onConfirmProvince"
                @cancel="showPickerPro = false"
              />
            </van-popup>
          </template>
          <!-- 城市 -->
          <template v-if="item.key === 'City'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                :readonly="true"
                v-model="formMg.City"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.City"
                :disabled="formMg.Country !== '中国'"
              >
              </van-field>
              <select
                v-model="formMg.City"
                :disabled="formMg.Country !== '中国'"
              >
                <option
                  v-for="(item, index) in columnsCity"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.City"
              is-link
              readonly
              :name="item.key"
              :label="item.Name"
              @click="columnsCity.length > 0 ? (showShopPicker = true) : ''"
              :rules="rulesAll.City"
              :disabled="formMg.Country !== '中国'"
            />
            <van-popup v-model:show="showShopPicker" position="bottom">
              <van-picker
                :columns="columnsCity"
                @confirm="shopConfirm"
                @cancel="showShopPicker = false"
              />
            </van-popup>
          </template>
          <!-- 行业 -->
          <template v-if="item.key === 'Trade'">
            <!-- pc -->
            <!-- <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.Trade"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.Trade"
              >
              </van-field>
              <select v-model="formMg.Trade">
                <option
                  v-for="(item, index) in item.Options"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div> -->
            <!-- 移动 -->
            <van-field
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.Trade"
              :name="item.key"
              :label="item.Name"
              @click="showTradePicker = true"
              :rules="rulesAll.Trade"
              readonly
            />
            <van-popup v-model:show="showTradePicker" position="bottom">
              <van-cascader
                v-model="cascaderValue"
                title="请选择"
                :options="options"
                @close="showTradePicker = false"
                @finish="onFinish"
              />
            </van-popup>
          </template>
          <!-- ExtField1 -->
          <template v-if="item.key === 'ExtField1'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField1"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.ExtField1"
              >
              </van-field>
              <select v-model="formMg.ExtField1">
                <option
                  v-for="(item, index) in ExtField1Ops"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField1"
              :name="item.key"
              :label="item.Name"
              @click="showF1Picker = true"
              :rules="rulesAll.ExtField1"
              readonly
            />
            <van-popup v-model:show="showF1Picker" position="bottom">
              <van-picker
                :columns="ExtField1Ops"
                @confirm="f1Confirm"
                @cancel="showF1Picker = false"
              />
            </van-popup>
          </template>
          <!-- ExtField2 -->
          <template v-if="item.key === 'ExtField2'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.ExtField2"
                :name="item.key"
                :label="item.Name"
                :rules="rulesAll.ExtField2"
              >
              </van-field>
              <select v-model="formMg.ExtField2">
                <option
                  v-for="(item, index) in ExtField2Ops"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.IsMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.ExtField2"
              :name="item.key"
              :label="item.Name"
              @click="showF2Picker = true"
              :rules="rulesAll.ExtField2"
              readonly
            />
            <van-popup v-model:show="showF2Picker" position="bottom">
              <van-picker
                :columns="ExtField2Ops"
                @confirm="f2Confirm"
                @cancel="showF2Picker = false"
              />
            </van-popup>
          </template>
          <!-- 身份证件类型 -->
          <template v-if="item.key === 'IDCardType'">
            <!-- pc -->
            <div class="fakeSel" v-if="isPC">
              <van-field
                :class="item.isMust ? 'requiredItem selItem' : 'selItem'"
                v-model="formMg.IDCardType"
                :name="item.key"
                :label="item.name"
                :rules="rulesAll.IDCardType"
                :placeholder="item.holder"
              >
              </van-field>
              <select v-model="formMg.IDCardType">
                <option
                  v-for="(item, index) in IDTypes"
                  :key="index"
                  :value="item.text"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <!-- 移动 -->
            <van-field
              v-else
              :class="item.isMust ? 'requiredItem selItem' : 'selItem'"
              v-model="formMg.IDCardType"
              is-link
              readonly
              :name="item.key"
              :label="item.Name"
              @click="showIDTypePicker = true"
              :rules="rulesAll.IDCardType"
              :placeholder="item.holder"
            />
            <van-popup v-model:show="showIDTypePicker" position="bottom">
              <van-picker
                :columns="IDTypes"
                @confirm="IDTypeConfirm"
                @cancel="showIDTypePicker = false"
              />
            </van-popup>
          </template>
        </div>
      </van-cell-group>
       <mz v-model="checked" />
      <div style="margin: 16px">
        <van-button :color="btnColor" type="primary" native-type="submit" round>
          下一步
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import cropper from '@/components/cropper.vue'
import { showFailToast } from 'vant'
import mz from '@/components/mz.vue'
import {
  validatorName,
  validatorComName,
  validatorGender,
  validatorRank,
  validateDept,
  validatorMobile,
  validatorEmail,
  validatorAddress,
  validatorUrl,
  validatorFax,
  validateZipCode
} from '@/utils/validators.js'
import { regCId, regIDNumber } from '@/utils/regs.js'
import api from '@/api'
// import cpc from '@/utils/cpc.js'
// import { constants } from 'fs'
import step from '@/components/step.vue'
import company from '@/assets/company.png'
import wwx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
const store = useStore()
const selectedCount = ref(0)

const token = computed(() => store.state.token)
const ExhCode = computed(() => store.state.ExhCode)
const loginForm = computed(() => store.state.loginForm)
const isPC = computed(() => store.state.isPC)
const openid = computed(() => store.state.openid)
const mainColor = computed(() => store.state.mainColor)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const isWeX = computed(() => store.state.isWeX)
const tabac = ref(sessionStorage.getItem('tabac'))
const router = useRouter()
const route = useRoute()
const actid = route.query.id

// 在 script setup 中添加相关逻辑

// 获取行业
// 选项列表，children 代表子选项，支持多级嵌套
const options = ref([])
const dealDict = (arr) => {
  const newArr = arr.map((item) => {
    const tmpObj = {}
    tmpObj.text = item.dictLabel
    tmpObj.value = item.dictValue
    if (item.children && item.children.length > 0) {
      tmpObj.children = dealDict(item.children)
    }
    return tmpObj
  })
  return newArr
}
const getIndus = async (dictType) => {
  const res = await api.dictApi({
    DicttreeType: dictType,
    ExhCode: ExhCode.value
  })
  if (res.code === 200) {
    options.value = dealDict(res.data)
    console.log(options.value, 'kkkkkkkkk')
  }
}
getIndus('industry')

const cascaderValue = ref('')

// 全部选项选择完毕后，会触发 finish 事件

const onFinish = ({ selectedOptions }) => {
  console.log(selectedOptions)
  showTradePicker.value = false
  formMg.value.Trade = selectedOptions.map((option) => option.text).join('/')
  formMg.value.TradeValues = selectedOptions
    .map((option) => option.value)
    .join(',')
}
onMounted(() => {
  getForm()
  if (actid) {
    getMeetDetail()
  }
  if (isWeX.value) {
    wwx.getWXSign()
  }
})
const formMg = ref({
  Name: '',
  ComName: '',
  Gender: '', // n
  Rank: '',
  Dept: '', // n
  Mobile: loginForm.value.mobile || '',
  Country: '中国',
  Province: '',
  City: '',
  Email: loginForm.value.Email || '',
  Address: '',
  WebUrl: '', // n
  Fax: '', // n
  Tel: '',
  IDCardNo: '',
  Trade: '', // n
  ZipCode: '', // n
  Remark: '', // n
  photo: '',
  IDCardType: '',
  OpenID: '',
  AliID: '',
  IsGroup: ''
})
// 校验省份
const validatorProvince = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      console.log('shengsheng')
      return false
    }
    return true
  }
  return true
}
const nvactor = (uuid) => {
  wx.miniProgram.navigateTo({
    url: '/pages/company/company/detail/companyDetail?companyGuid=' + uuid
  })
}
// 校验城市
const validatorCity = (val, { required }) => {
  if (required) {
    if (formMg.value.Country === '中国') {
      if (val) {
        return true
      }
      return false
    }
    return true
  }
  return true
}
// 校验证件号
const validatorIDCardNo = (val, { required }) => {
  if (required) {
    if (val) {
      if (
        formMg.value.IDCardType === '中国大陆居民身份证' ||
        formMg.value.Country === '中国' ||
        (formMg.value.IDCardType === '' && formMg.value.Country === '')
      ) {
        return regCId(val)
      } else {
        return regIDNumber.test(val)
      }
    }
    return false
  }
  return true
}

const vlidateMobileHn = (val, { required }) => {
  if (formMg.value.Country === '中国') {
    return validatorMobile(val, { required })
  } else {
    return true
  }
}

const rulesAll = ref({})
const rulesModel = {
  Name: [
    { required: false, validator: validatorName, message: '请输入正确的' }
  ],
  ComName: [
    { required: false, validator: validatorComName, message: '请输入正确的' }
  ],
  ComEName: [{ required: false, message: '请输入' }],
  Gender: [{ required: false, validator: validatorGender, message: '请选择' }],
  Rank: [
    { required: false, validator: validatorRank, message: '请输入正确的' }
  ],
  Dept: [{ required: false, validator: validateDept, message: '请输入' }],
  Mobile: [
    {
      required: false,
      validator: vlidateMobileHn,
      message: '请输入正确的'
    }
  ],
  Country: [{ required: false, message: '请选择' }],
  Province: [
    { required: false, validator: validatorProvince, message: '请选择' }
  ],
  City: [{ required: false, validator: validatorCity, message: '请选择' }],
  Email: [
    { required: false, validator: validatorEmail, message: '请输入正确的' }
  ],
  Address: [
    {
      required: false,
      validator: validatorAddress,
      message: '请输入正确的'
    }
  ],
  WebUrl: [
    { required: false, validator: validatorUrl, message: '请输入正确的' }
  ],
  Fax: [{ required: false, validator: validatorFax, message: '请输入正确的' }],
  Tel: [{ required: false, validator: validatorFax, message: '请输入正确的' }],
  IDCardNo: [
    { required: false, validator: validatorIDCardNo, message: '请输入正确的' }
  ],
  Trade: [{ required: false, message: '请选择' }],
  ZipCode: [
    { required: false, validator: validateZipCode, message: '请输入正确的' }
  ],
  Remark: [{ required: false, message: '请输入' }],
  photo: [{ required: true, message: '请上传' }],
  IDCardType: [{ required: true, message: '请选择' }],
  ExtField1: [{ required: true, message: '请选择' }],
  ExtField2: [{ required: true, message: '请选择' }]
}
// 解析选项
const dealOp = (str) => {
  if (str) {
    return str.split(';').map((item) => {
      return { text: item, value: item }
    })
  } else {
    return []
  }
}
// 行业选项
const tradeOptions = ref([])
const ExtField1Ops = ref([])
const ExtField2Ops = ref([])
// 获取信息配置
const formItems = ref([])
const getForm = async () => {
  const res = await api.formConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const formObj = JSON.parse(decryptionECB(res.data.configuartion))
    // console.log(JSON.stringify(formObj), 123)
    formItems.value = formObj
      .filter((item) => item.IsShow)
      .sort((a, b) => {
        return a.Sort - b.Sort
      })
    formItems.value.forEach((item) => {
      if (
        item.key === 'Gender' ||
        item.key === 'Country' ||
        item.key === 'Province' ||
        item.key === 'City' ||
        item.key === 'Trade' ||
        item.key === 'photo' ||
        item.key === 'IDCardType' ||
        item.key === 'ExtField1' ||
        item.key === 'ExtField2'
      ) {
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.Name
        if (item.key === 'Trade') {
          tradeOptions.value = dealOp(item.Options)
        }
        if (item.key === 'ExtField1') {
          ExtField1Ops.value = dealOp(item.Options)
        }
        if (item.key === 'ExtField2') {
          ExtField2Ops.value = dealOp(item.Options)
        }
      } else {
        rulesModel[item.key][0].message =
          rulesModel[item.key][0].message + item.Name
      }
      rulesModel[item.key][0].required = item.IsMust
      rulesAll.value[item.key] = rulesModel[item.key]
    })
  }
}
// 关闭上传头像
const sendphoto = (data) => {
  console.log(formMg.value, 12333)
  formMg.value.photo = data
  Object.assign(formMg.value, { photo: data })
}
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}

const confirmsubmit = async () => {
  const subObj = { ...formMg.value }
  subObj.photoUrl = subObj.photo
  subObj.Trade = formMg.value.TradeValues
  // console.log(subObj)
  // return
  // 是否有调查问卷
  const hasQues = gconfig.value.IsHaveQuestion === 'True'
  // 是否需要审核
  // const needCheck = gconfig.value.IsNeedCheck === 'True'
  const param = {
    ...subObj,
    ExhCode: ExhCode.value,
    token: token.value,
    ifSubmit: !hasQues,
    OpenID: openid.value,
    AliID: '',
    source: sessionStorage.getItem('source') || '',
    invitesource: sessionStorage.getItem('invitesource') || '',
    invitesourceid: sessionStorage.getItem('invitesourceID') || '',
    lan: 'cn',
    IsGroup: sessionStorage.getItem('IsGroup') || ''
  }
  const res = await api.visitorSaveApi(param)
  if (res.code === 200) {
    if (hasQues) {
      router.push({ path: '/questions' })
      return
    }
    store.commit('setVisitorID', res.data.visitorID)
    sessionStorage.setItem('invitesourceID', res.data.visitorID)
    if (gconfig.value.SuccessPageVersion === 'V2') {
      router.push({ path: '/successV2' })
    } else {
      router.push({ path: '/success' })
    }
  }
}
// 免责勾选
const checked = ref(false)
// 表单验证成功提交
const onSubmit = async (values) => {
  if (!checked.value) {
    showFailToast('请勾选《用户协议》、《商贸邀约协议》、《隐私政策》')
    return
  }
  confirmsubmit()
}
// 行业下拉
const showTradePicker = ref(false)
// const tradeConfirm = ({ selectedOptions }) => {
//   formMg.value.Trade = selectedOptions[0].text
//   showTradePicker.value = false
// }
// ExtField1 下拉
const showF1Picker = ref(false)
const f1Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField1 = selectedOptions[0].text
  showF1Picker.value = false
}
// ExtField2 下拉
const showF2Picker = ref(false)
const f2Confirm = ({ selectedOptions }) => {
  formMg.value.ExtField2 = selectedOptions[0].text
  showF2Picker.value = false
}
// 国家下拉
const showPicker = ref(false)
const columns = ref([])
// columns.value = cpc.country1.map((item) => {
//   const tmpArr = item.split('_')
//   return { text: tmpArr[1], value: tmpArr[0] }
// })
const getCountry = () => {
  api.countryApi({}).then((res) => {
    columns.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
getCountry()
const onConfirm = ({ selectedOptions }) => {
  formMg.value.Country = selectedOptions[0].text
  showPicker.value = false
  changeCountry()
}
// 国家变化
const changeCountry = () => {
  formMg.value.Province = ''
  formMg.value.City = ''
  columnsProvince.value = []
  columnsCity.value = []
  if (formMg.value.Country === '中国') {
    getProsH()
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.City
    const findPObj = formItems.value.find((item) => item.key === 'Province')
    if (findPObj) {
      if (findPObj.IsMust) {
        // 如果必选
        pRule[0].required = true
      } else {
        pRule[0].required = false
      }
    }
    const findCObj = formItems.value.find((item) => item.key === 'City')
    if (findCObj) {
      if (findCObj.IsMust) {
        // 如果必选
        cRule[0].required = true
      } else {
        cRule[0].required = false
      }
    }
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  } else {
    // 修改省份/城市验证
    const pRule = rulesAll.value.Province
    const cRule = rulesAll.value.Province
    pRule[0].required = false
    cRule[0].required = false
    Object.assign(rulesAll.value, { Province: pRule, City: cRule })
    // 修改省份/城市验证 end
  }
  if (formMg.value.Country === '中国') {
    formMg.value.IDCardType = '中国大陆居民身份证'
  } else if (
    formMg.value.Country === '中国香港' ||
    formMg.value.Country === '中国澳门'
  ) {
    formMg.value.IDCardType = '港澳通行证'
  } else if (formMg.value.Country === '中国台湾') {
    formMg.value.IDCardType = '台胞证'
  } else {
    formMg.value.IDCardType = '护照'
  }
}
// 省份下拉
// 获取省份下拉选项
const columnsProvince = ref([])
const getProsH = () => {
  // columnsProvince.value = cpc.province.map((item) => {
  //   const tmpArr = item.split('_')
  //   return { text: tmpArr[2], value: tmpArr[1] }
  // })
  api.proApi({}).then((res) => {
    columnsProvince.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
getProsH()
const showPickerPro = ref(false)
const onConfirmProvince = ({ selectedOptions }) => {
  formMg.value.Province = selectedOptions[0].text
  showPickerPro.value = false
  changeProvince()
}
// 省份变化
const changeProvince = () => {
  formMg.value.City = ''
  columnsCity.value = []
  getCity()
}
// 城市
// 城市下拉
const columnsCity = ref([])
const getCity = () => {
  columnsCity.value = []
  // cpc.city.map((item) => {
  //   const tmpArr = item.split('_')
  //   if (formMg.value.Province === tmpArr[1]) {
  //     columnsCity.value.push({ text: tmpArr[3], value: tmpArr[2] })
  //   }
  // })
  api.cityApi({ name: formMg.value.Province }).then((res) => {
    columnsCity.value = res.data.map((item) => {
      return { text: item.name, value: item.name }
    })
  })
}
const showShopPicker = ref(false)

const shopConfirm = ({ selectedOptions }) => {
  formMg.value.City = selectedOptions[0].text
  showShopPicker.value = false
}
// 身份证件类型
const IDTypes = ref([
  { text: '中国大陆居民身份证', value: '中国大陆居民身份证' },
  { text: '港澳通行证', value: '港澳通行证' },
  { text: '台胞证', value: '台胞证' },
  { text: '护照', value: '护照' }
])
const showIDTypePicker = ref(false)
const IDTypeConfirm = ({ selectedOptions }) => {
  formMg.value.IDCardType = selectedOptions[0].text
  showIDTypePicker.value = false
}
// 获取会议详情
const getMeetDetail = async () => {
  const res = await api.getActiviInfoApi({ token: token.value, ActID: actid })
  formMg.value = { ...res.data }
  formMg.value.Name = res.data.RecipientName
}
const btnColor = ref(
  'linear-gradient( 90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)'
)
</script>
<style lang="less">
@import '../../assets/login.less';
.product-names {
  font-size: 0.7rem;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.product-images-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-top: 8px;
  /* 隐藏滚动条但保持功能 */
}

.product-images-container::-webkit-scrollbar {
  display: none;
}

.product-images {
  display: flex;
  gap: 8px;
  padding: 4px 0;
  width: max-content;
  /* 防止内容溢出到页面上 */
  max-width: 100%;
}

.product-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}
/* 在样式部分添加确认弹窗样式 */
.confirm-modal-content {
  padding: 20px;
  text-align: center;
}

.confirm-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.confirm-message {
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
}

.confirm-buttons {
  display: flex;
   justify-content: space-around;
  gap: 20px; /* 添加按钮间的间隔 */
}

.confirm-btn-cancel, .confirm-btn-confirm {
  width: 40%;
}
.favobox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3vw;
  background: #fff2f4;
  .favoL {
    text-align: left;
    h3 {
      font-size: 1em;
      color: #783651;
      padding-bottom: 1vw;
    }
    p {
      color: #712c49;
      font-size: 0.9em;
    }
    span {
      font-size: 0.7em;
      color: #817e7e;
    }
  }
}
.favoCon {
  .favoTit {
    font-size: 1em;
    padding: 3vw 0;
    text-align: left;
    text-indent: 1em;
    color:#481425;
  }
  .favoListBox {
    height: 120vw;
    overflow: scroll;
    padding-bottom: 22vw;
  }
  ul {
    width: 92%;
    margin: 0 auto;
    .favoItem {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid #ececec;
  padding: 2vw;
  margin-bottom: 2vw;
  border-radius: 8px;
    flex: 1;
    min-width: 0; /* 允许内容收缩 */
    .favoItemMsg {
      display: flex;
      width:100%;
      .imgBox {
        width: 15vw;
        height: 15vw;
        padding: 1vw;
        border: 1px solid #ececec;
        margin-right: 2vw;
        flex-shrink: 0; /* 防止图片区域被压缩 */
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .atrName {
        max-width: 80%;
        flex: 1;
        min-width: 0; /* 允许内容收缩 */
        text-align: left;
        p {
          font-size: 0.9em;
          word-wrap: break-word; /* 允许长文本换行 */
        }
        .bthNum {
          font-size: 0.7rem;
          color: #817e7e;
          padding-top: 1vw;
          span {
            font-weight: bold;
            color: #55A972;
          }
        }
      }
    }
  .favo-checkbox {
    margin-left: 10px;
    margin-top: 1vw;
    flex-shrink: 0; /* 防止复选框被压缩 */
  }
}
  }
  .favo-btm-box {
    position: fixed;
    bottom: 0;
    padding: 3vw 5vw;
    left: 0;
    width: 100%;
    background: #fff;
    height: 20vw;
  }
}
.lcbox {
  border: 1px solid #ececec;
  box-sizing: border-box;
  width: 99vw;
  border-radius: 3px;
  margin: 10px auto 0;
}
.fakeSel {
  position: relative;
  .van-field__value {
    opacity: 0;
  }
  select {
    position: absolute;
    top: 50px;
    left: 16px;
    padding: 13px 0;
    width: 93%;
    border: 1px solid #666;
    border-radius: 6px;
    outline: none;
    background: transparent;
    font-weight: normal;
    color: #323233;
    option {
      color: #323233;
    }
  }
}
.formDiv {
  padding: 0 4px;
  width: 92%;
  margin: 0 auto;
  border-radius: 6px;
  button {
    width: 70% !important;
  }
}
// 头像
.photoForm {
  .van-field__value {
    text-align: center;
  }
  .van-field__body {
    display: inline-block;
    border: 0;
  }
}
@media screen and (min-width: 768px) {
  .favoCon {
    .favoListBox {
      height: 44vw;
      .favoItem {
    padding: 12px;
    margin-bottom: 12px;
      .favoItemMsg {
        .imgBox {
          width: 60px;
          height: 60px;
        }
      }
    .favo-checkbox {
      margin-top: 12px;
    }
  }
    }
  }
}
</style>
